// extracted by mini-css-extract-plugin
module.exports = {"courts":"PeopleAdmissions_courts__AEa53","pdf":"PeopleAdmissions_pdf__Xl_aq","subhead":"PeopleAdmissions_subhead__WAo9_","search-fade-in":"PeopleAdmissions_search-fade-in__QKSsk"};